export const ADMIN_ACTIONS = {
    SET_EDIT_LOCATION: "SET_EDIT_LOCATION",
    SET_ACTIVE_BTN_NAME: "SET_ACTIVE_BTN_NAME",
    SET_PRICING_VARS: "SET_PRICING_VARS",
    RESET_ADMIN: "RESET_ADMIN"
}